module.exports = __webpack_public_path__ + "static/media/kayle.838150d0.png";